export const ROUTES = {
  NOT_FOUND: '*',
  HOME: '/',
  LOGIN: '/login',
  USERS: '/user',
  PRODUCT: '/product',
  PRODUCT_CATEGORY: '/category',
  ORDER: '/order',
  REPORT: '/report',
  BANNER_IMAGE: '/banner-image',
  PROMOTIONAL_BANNER: '/promotional-banner',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITION: '/terms-condition',
  CATALOGUE: '/catalogue',
  SPARE_PART: '/spare-part',
};

export const DATE_FORMAT = {
  'MM/DD/YYYY': 'MM/DD/YYYY', // 11-22-2022
};

export const API_URL = 'https://api.megakitchensystem.in/';

export const API_END_POINT = {
  GET_PRODUCT_CATEGORY_LIST: 'ProductCategory/getProductCategoryList',
  GET_USER_LIST: 'Company/GetCompanyLists',
  UPDATE_USER_APPROVAL: 'Company/ApproveCompany',
  ADD_PRODUCT_CATEGORY: 'ProductCategory/AddProductCategory',
  GET_ALL_PRODUCT: 'Product/GetListOfProductforAdmin',
  ADD_PRODUCT: 'Product/AddProduct',
  GET_ALL_ORDERS: 'Order/GetOrderList',
  LOGIN: 'Account/Login',
  SEND_LOGIN_OTP: 'Account/SendLoginOtp',
  REFRESH_TOKEN: 'Account/GetRefreshToken',
  LOGOUT: 'Account/Logout',
  GET_BANNER_IMAGE: 'Banner/GetBannerList',
  ADD_BANNER_IMAGE: 'Banner/AddBanner',
  GET_PROMOTIONAL_BANNER_LIST: 'PromotionalBaneer/GetPromotionalBanners',
  ADD_PROMOTIONAL_BANNER: 'PromotionalBaneer/AddPromotionalBanner',
  DELETE_PROMOTIONAL_BANNER: 'PromotionalBaneer/DeleteBanner',
  DELETE_PRODUCT_IMAGE: 'Product/DeleteProductImage',
  UPDATE_PRODUCT: 'Product/UpdateProduct',
  UPDATE_PRODUCT_CATEGORY: 'ProductCategory/updateProductCategory',
  ADD_PRODUCT_IMAGE: 'Product/AddProductImage',
  DELETE_BANNER: 'Banner/DeleteBannerImage',
  UPDATE_ORDER_STATUS: 'Order/UpdateOrderStatus',
  DELETE_PRODUCT: 'Product/DeleteProduct',
  DELETE_PRODUCT_CATEGORY: 'ProductCategory/removeProductCategory',
  GET_PRIVACY_POLICY: 'PrivacyPolicy/GetPrivacyPolicy',
  UPDATE_PRIVACY_POLICY: 'PrivacyPolicy/UpdatePrivacyPolicy',
  GET_TERMS_AND_CONDITION: 'TermAndCondition/GetTermAndCondition',
  UPDATE_TERMS_AND_CONDITION: 'TermAndCondition/UpdateTermAndCondition',
  ADD_CATALOGUE: 'Brochure/AddNewBrochure',
  GET_CATALOGUE: 'Brochure/GetBrochure',
  GET_SPARE_PART: 'ProductSparePart/GetProductSparePart',
  ADD_SPARE_PART: 'ProductSparePart/AddProductSparePart',
  UPDATE_SPARE_PART: 'ProductSparePart/UpdateProductSparePart',
  ADD_PRODUCT_SPARE_PART_IMAGE: 'ProductSparePart/AddProductSpareImage',
  DELETE_SPARE_PART: 'ProductSparePart/DeleteProductSparePart',
  GET_PRODUCT_PRICE_CATEGORY: 'ProductPriceCategory/GetProductPriceCategory',
  ADD_PRODUCT_PRICE_CATEGORY:
    'ProductPriceCategory/AssignProductPriceCategoryToCompany',
  UPDATE_SALES_PERSON: 'Company/UpdateSalesPerson',
  CHECK_MOBILE_NUMBER_EXISTS: 'Company/CheckMobileNumberExists',
  GET_GST_NUMBER_DETAILS: 'Company/GetGSTNumberDetails',
  REGISTER_COMPANY_FROM_ADMIN: 'Company/RegisterCompanyFromAdmin',
  UPLOAD_IMAGE: 'Image/uploadImage',
  GET_ADDRESS_LIST_BY_COMPANY: 'Address/getAddressListByCommpny',
  ADD_ADDRESS: 'Address/addNewAddress',
  GET_PRODUCT_OPTIONS: 'Product/GetProductOptions/lookup',
  GET_SPARE_PART_OPTIONS: 'ProductSparePart/ProductSparePartLookup',
  PLACE_ORDER: 'Order/PlaceOrder',
  GET_COMPANY_DROPDOWN_LISTS: 'Company/GetCompanyDropDownLists',
};

export const SOMETHING_WENT_WRONG = 'Something went wrong, Please try again.';

export const AUTH_COOKIE_TOKEN = 'auth_token';
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export const ORDER_STATUS = [
  { key: 'Confirmed', value: 'Confirmed' },
  { key: 'Processing', value: 'Processing' },
  { key: 'ReadyToDispatch', value: 'ReadyToDispatch' },
  { key: 'OutForDelivery', value: 'OutForDelivery' },
  { key: 'Cancelled', value: 'Cancelled' },
];

export const S3ImageFolder = {
  Product: 1,
  ProductCategory: 2,
  Banner: 3,
  Profile: 4,
  Expanse: 5,
  Payment: 6,
  Order: 7,
  MeetUp: 8,
  Onboarding: 9,
  Catalogue: 10,
  PromotionalBanner: 11,
  SubPart: 12,
};
